export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-02.936fa62a.jpg";